import { Outlet } from "react-router";

const LabpartnerIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LabpartnerIndexPage;
